import { ACTION_TYPE } from "./type";
import Config from "../../utilities/config";
import {
  getSEOData,
  productDescription,
  productfilterlistitem,
  productlistitems,
  productSizeList,
} from "../../utilities/api";
import config from "../../utilities/config";

export const product_description = (skuId) => async (dispatch) => {
  // dispatch({ type: ACTION_TYPE.GET_PRODUCT_DATA_REQUEST });
  try {
    const product_description_data = await productDescription(skuId);
    Config.logGeneral &&
      config.logGeneral && console.log(
        product_description_data,
        "product_description_data 77777777"
      );

    if (
      product_description_data?.data?.data?.allTransSkuLists?.nodes?.length > 0
    ) {
      dispatch({
        type: ACTION_TYPE.GET_PRODUCT_DATA_RESPONSE_SUCCESS, //GET_PRODUCT_DATA_RESPONSE_SUCCESS
        payload: {
          productResponseSuccess:
            product_description_data?.data?.data?.allTransSkuLists?.nodes,
        },
      });
    } else {
      dispatch({
        type: ACTION_TYPE.GET_PRODUCT_DATA_RESPONSE_FAILURE,
        errorMessage: "No data found!!",
      });
    }
  } catch (error) {
    Config.logGeneral &&
      config.logGeneral && console.log("Error productDescriptionResponseError", error);
    dispatch({
      type: ACTION_TYPE.GET_PRODUCT_DATA_RESPONSE_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};
export const getProductSizeList = (skuSizes, productId) => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_PRODUCT_SIZE_DATA_REQUEST });

  try {
    const sizeListResponse = await productSizeList(skuSizes, productId);

    dispatch({
      type: ACTION_TYPE.GET_PRODUCT_SIZE_DATA_RESPONSE_SUCCESS,
      payload: {
        productSizeResponseSuccess: sizeListResponse,
      },
    });
  } catch (error) {
    dispatch({
      type: ACTION_TYPE.GET_PRODUCT_SIZE_DATA_RESPONSE_FAILURE,
      errorMessage: error,
    });
  }
};

export const product_list_filter_category = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_SEARCH_CATEGORY_DATA_REQUEST });
  try {
    const product_list_filter_data = await productfilterlistitem();
    dispatch({
      type: ACTION_TYPE.GET_SEARCH_CATEGORY_DATA_RESPONSE_SUCCESS,
      payload: {
        searchcategoryResponseSuccess: product_list_filter_data?.data,
      },
    });
  } catch (error) {
    dispatch({
      type: ACTION_TYPE.GET_SEARCH_CATEGORY_DATA_RESPONSE_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};

export const product_list_filter = (filtervalue) => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_PRODUCT_FILTER_LIST_DATA_REQUEST });
  config.logGeneral && console.log(filtervalue, "abcxss");
  var filter = {};
  filtervalue?.forEach((element) => {
    filter[element.attributeName.toLowerCase().replace(" ","")] = element.attributeValue;
  });
  try {
    const product_list_filter_data = await productfilterlistitem(filter);
    Config.logGeneral &&
      config.logGeneral && console.log(
        product_list_filter_data,
        "product_list_filter_data 77777777"
      );

    dispatch({
      type: ACTION_TYPE.GET_PRODUCT_FILTER_LIST_DATA_SUCCESS, //GET_PRODUCT_DATA_RESPONSE_SUCCESS
      payload: {
        productResponseSuccess: product_list_filter_data?.data,
      },
    });
  } catch (error) {
    Config.logGeneral &&
      config.logGeneral && console.log("Error productDescriptionResponseError", error);
    dispatch({
      type: ACTION_TYPE.GET_PRODUCT_FILTER_LIST_DATA_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};

export const product_list_item = (productfil, offSet) => async (dispatch) => {
  config.logGeneral && console.log("===>product_list_item", productfil);

  dispatch({ type: ACTION_TYPE.GET_PRODUCT_LIST_DATA_REQUEST });
  try {
    const product_list_item_data = await productlistitems(productfil, offSet);
    Config.logGeneral &&
      config.logGeneral && console.log(product_list_item_data, "product_list_item_data77");

    dispatch({
      type: ACTION_TYPE.GET_PRODUCT_LIST_DATA_SUCCESS,
      payload: {
        productListitemResponseSuccess: product_list_item_data?.data,
      },
    });
  } catch (error) {
    Config.logGeneral &&
      config.logGeneral && console.log("Error productlistitemResponseError", error);
    dispatch({
      type: ACTION_TYPE.GET_PRODUCT_LIST_DATA_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};

export const intProductListItem = () => async (dispatch) => {
  config.logGeneral && console.log("====>intProductListItem");

  dispatch({ type: ACTION_TYPE.GET_PRODUCT_LIST_DATA_REQUEST });
};
export const product_listing_loading = () => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_PRODUCT_LIST_DATA_LOADING_FALSE });
};

//Get the SEO Data for filters
export const fetchSEOData = (condition) => async (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_SEO_DATA_REQUEST });

  try {
    const getSEODataList = await getSEOData(condition);
    Config.logGeneral &&
      config.logGeneral && console.log(getSEODataList, condition, "==>apigetSEOData");

    dispatch({
      type: ACTION_TYPE.GET_SEO_DATA_SUCCESS,
      payload: {
        getSEODataResponseSuccess: getSEODataList?.data,
      },
    });
  } catch (error) {
    config.logGeneral && console.log("Error getSEOData", error);
    dispatch({
      type: ACTION_TYPE.GET_SEO_DATA_FAILURE,
      errorMessage: error?.response?.data?.message,
    });
  }
};
